import { FormType } from '../../../form-types';
import { WeightLossFieldAnswers } from '../questions';


// ONLY for products that are branded IE Ozempic and Wegovy
export const wlusBranded: FormType<WeightLossFieldAnswers> = {
  name: 'Branded Weight Loss',
  'olderVersions': ["wlus_2024"],
  questions: [
    {
      key: 'wlus_genderIdentify',
      next: {
        condition: { 'wlus_genderIdentify.wlus_genderIdentify_female': true },
        key: 'wlus_pregnantOrBreastfeedingOrPlanningTo2',
        els: 'wlus_weightAndHeight2025'
      }

    },
    {
      key: 'wlus_pregnantOrBreastfeedingOrPlanningTo2',
      next: {
        condition: { 'wlus_pregnantOrBreastfeedingOrPlanningTo2.yes': true },
        key: 'wlus_ineligible',
        els: 'wlus_weightAndHeight2025'
      }
    },
    'wlus_weightAndHeight2025',
    {
      key: 'wlus_medicalConditions2',
      next: {
        switch: [
          {
            condition: { 'wlus_medicalConditions2.gastroparesis': true },
            key: 'wlus_ineligible'
          },
          {
            condition: { 'wlus_medicalConditions2.triglyceridesOver600': true },
            key: 'wlus_ineligible'
          },
          {
            condition: { 'wlus_medicalConditions2.pancreaticCancerOrPancreatitis': true },
            key: 'wlus_ineligible'
          },
          {
            condition: { 'wlus_medicalConditions2.type1Diabetes': true },
            key: 'wlus_ineligible'
          },
          {
            condition: { 'wlus_medicalConditions2.hypoglycemia': true },
            key: 'wlus_ineligible'
          },
          {
            condition: { 'wlus_medicalConditions2.medullaryThyroidCancer': true },
            key: 'wlus_ineligible'
          },
          {
            condition: { 'wlus_medicalConditions2.men2': true },
            key: 'wlus_ineligible'
          },
          {
            condition: { 'wlus_medicalConditions2.anorexiaOrBulimia': true },
            key: 'wlus_ineligible'
          },
          {
            condition: { 'wlus_medicalConditions2.liverFailure': true },
            key: 'wlus_ineligible'
          },
          {
            condition: { 'wlus_medicalConditions2.ckd3b': true },
            key: 'wlus_ineligible'
          },
          {
            condition: { 'wlus_medicalConditions2.siadh': true },
            key: 'wlus_ineligible'
          },
          {
            condition: { 'wlus_medicalConditions2.symptomaticGallstones': true },
            key: 'wlus_ineligible'
          },
          {
            condition: { 'wlus_medicalConditions2.gastricBypass6Months': true },
            key: 'wlus_ineligible'
          },
          {
            condition: { 'wlus_medicalConditions2.gallstonesNoSymptoms': true },
            key: 'wlus_consentGallstones'
          },
          {
            condition: { 'wlus_medicalConditions2.gallbladderRemoved': true },
            key: 'wlus_consentCholecystectomy'
          },

          {
            condition: { 'wlus_medicalConditions2.none': true },
            key: 'wlus_allergicToGlp1'
          }
        ],
        els: 'wlus_tellUsMoreAboutAboutYourMedicalConditions'
      }
    },
    {
      key: 'wlus_consentGallstones',
      next: {
        switch: [
          {
            condition: {
              'wlus_consentGallstones.consent': true,
              'wlus_medicalConditions2.gallbladderRemoved': true
            },
            key: 'wlus_consentCholecystectomy'
          },
          {
            condition: {
              'wlus_consentGallstones.non_consent': true,
            },
            key: 'wlus_ineligible'
          }

        ],
        els: 'wlus_tellUsMoreAboutAboutYourMedicalConditions'
      }
    },

    {
      key: 'wlus_consentCholecystectomy',
      next: {
        condition: {
          'wlus_consentCholecystectomy.consent': true
        },
        key: 'wlus_tellUsMoreAboutAboutYourMedicalConditions',
        els: 'wlus_ineligible'
      }
    },
    'wlus_tellUsMoreAboutAboutYourMedicalConditions',
    {
      key: 'wlus_allergicToGlp1',
      next: {
        condition: {
          'wlus_allergicToGlp1.wlusBranded_allergicToGlp1_yes': true
        },
        key: 'wlus_ineligible',
        els: 'wlus_doYouTakeAnyOfTheFollowingMedications'
      }
    },
    {
      key: 'wlus_doYouTakeAnyOfTheFollowingMedications',
      next: {
        condition: {
          'wlus_doYouTakeAnyOfTheFollowingMedications.wlus_doYouTakeAnyOfTheFollowingMedications_no': true
        },
        key: 'wlus_weightLossMedicationsPast4Weeks',
        els: 'wlus_ineligible'
      }
    },
    {
      key: 'wlus_weightLossMedicationsPast4Weeks',
      next: {
        condition: {
          'wlus_weightLossMedicationsPast4Weeks.wlus_weightLossMedicationsPast4Weeks_none': true
        },
        key: 'wlus_ableToInjectOrHaveHelp',
        els: 'wlus_whenLastTookMedication'
      }
    },
    {
      key: 'wlus_ableToInjectOrHaveHelp',
      next: {
        condition: {
          'wlus_ableToInjectOrHaveHelp.wlusBranded_ableToInjectOrHaveHelp_yes': true
        },
        key: 'wlus_otherInformationOrQuestionsDoYouHaveForTheDoctor',
        els: 'wlus_ineligible'
      }
    },
    {
      key: 'wlus_whenLastTookMedication',
      next: {
        condition: {
          'wlus_whenLastTookMedication.wlus_whenLastTookMedication_past2To4Weeks': true
        },
        key: 'wlus_consentDoseDecrease',
        els: 'wlus_ineligible'
      }
    },
    'wlus_consentDoseDecrease',
    'wlus_approximateDateLastInjected',
    'wlus_whichMedicationAndDoseMostCloselyMatchesYourMostRecentDose',
    {
      key: 'wlus_haveYouExperiencedSideEffectsFromYourCurrentMedication',
      next: {
        condition: {
          'wlus_haveYouExperiencedSideEffectsFromYourCurrentMedication.wlus_haveYouExperiencedSideEffectsFromYourCurrentMedication_yes': true
        },
        key: 'wlus_describeTheSideEffectsThatYouHaveExperienced',

        els: 'wlus_howWouldYouLikeToContinueYourTreatment'
      }
    },
    'wlus_describeTheSideEffectsThatYouHaveExperienced',
    'wlus_howWouldYouLikeToContinueYourTreatment',
    {
      key: 'wlus_doYouHaveAPictureOfYourCurrentPrescription',
      next: {
        condition: {
          'wlus_doYouHaveAPictureOfYourCurrentPrescription.wlus_doYouHaveAPictureOfYourCurrentPrescription_yes': true
        },
        key: 'wlus_pictureOfThePrescriptionOrBottleOfYourCurrentGlp_1GipMedication',
        els: 'wlus_otherInformationOrQuestionsDoYouHaveForTheDoctor'
      }
    },
    'wlus_pictureOfThePrescriptionOrBottleOfYourCurrentGlp_1GipMedication',
    'wlus_otherInformationOrQuestionsDoYouHaveForTheDoctor',
    'wlus_consentTruthfulness',
    'wlus_consentGLP1GIP',
    'wlus_complete',
    'wlus_ineligible'

  ]
};
